export default __webpack_public_path__ + "static/media/gallery_09.fa88cfe7.jpg";